import React from 'react'
import type { IconProps } from '@vtex/admin-ui'
import {
  IconBarcode,
  IconCreditCard,
  IconCurrencyCircleDollar,
  IconGift,
} from '@vtex/admin-ui'

const PAYMENT_GROUP_NAME_ICON_MAP: Record<string, any> = {
  giftCardPaymentGroup: IconGift,
  debitDirectSalePaymentGroup: IconCreditCard,
  creditDirectSalePaymentGroup: IconCreditCard,
  creditCardPaymentGroup: IconCreditCard,
  bankInvoicePaymentGroup: IconBarcode,
  instantPayment: IconCurrencyCircleDollar,
}

type PaymentMethodIconProps = IconProps & {
  groupName: string
}

export const PaymentMethodIcon = ({
  groupName,
  ...props
}: PaymentMethodIconProps) => {
  const Icon =
    PAYMENT_GROUP_NAME_ICON_MAP[groupName] ?? IconCurrencyCircleDollar

  return <Icon {...props} />
}
